import React from 'react';
import './ContactView.less';
import Button from '../../../common/js/app/Button/Button.jsx';
import ContactForm from '../../contact/ContactForm/ContactForm.jsx';
import {Row, Item, Column} from 'react-plan';
type Props = {

}

class ContactView extends React.Component {

  description: 'Shows a single contact page.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <div className="contact-view">
        <div className="bg-contact bg-img3">
          <div className="bloc-medium">
            <div className="p-t-xxl p-b-xl">
              <Row justify="space-around">
              <Item className="contact-bloc" size="50%" medium="100%"  small="100%" >
               <ContactForm />
              </Item>
              <Item>
              </Item>
                </Row>
             </div>
           </div>
         </div>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default ContactView;

//Unit test entry point
export const ContactViewTest = ContactView;


/** WEBPACK FOOTER **
 ** ./src/js/views/ContactView/ContactView.jsx
 **/